import * as React from 'react';
import {Query} from 'react-apollo';

// @ts-expect-error
import type {FieldArrayProps} from 'redux-form';

import type {
    GetGoalFields as GetGoalFieldsQuery,
    GetGoalFieldsVariables as GetGoalFieldsQueryVariables,
} from 'nutshell-graphql-types';

import GET_GOAL_FIELDS from '../../graphql/queries/get-goal-fields.graphql';

import {FieldLeadFieldsComponent} from './field-lead-fields-component';

type Props = {
    fields: FieldArrayProps['fields'];
    meta: FieldArrayProps['meta'];
};

class LeadFieldsQuery extends Query<GetGoalFieldsQuery, GetGoalFieldsQueryVariables> {}

export const FieldLeadFields = (props: Props) => (
    <LeadFieldsQuery
        query={GET_GOAL_FIELDS}
        // @ts-expect-error
        fetchPolicy='cache-and-network'
        variables={{entityType: 'leads', isGoalable: true}}
    >
        {({data, refetch}) => (
            <FieldLeadFieldsComponent
                {...props}
                refetchLeadFields={refetch}
                goalableFields={(data && data.entityFields) || []}
            />
        )}
    </LeadFieldsQuery>
);
